export const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string

// Clerk attaches itself to the window once loaded — this is how non-React code (the axios
// interceptor in api/client.ts, which runs outside the component tree and can't use hooks)
// reads the current session token, mirroring the old userManager.getUser() pattern.
declare global {
  interface Window {
    Clerk?: {
      session?: { getToken: (opts?: { skipCache?: boolean }) => Promise<string | null> } | null
      signOut?: () => Promise<void>
    }
  }
}

export async function getClerkToken(): Promise<string | null> {
  return (await window.Clerk?.session?.getToken()) ?? null
}
